﻿(function () {

    'use strict';
    var serviceId = 'repository.dryreefer';
    angular
        .module('app.services')
        .factory(serviceId, dryreefer);

    dryreefer.$inject = ['common', 'repository.abstract', '$http'];

    function dryreefer(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getdryreeferFilters = getdryreeferFilters;
            this.getdryreeferList = getdryreeferList;
            this.getdryreeferListExcel = getdryreeferListExcel;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?legend=dryreefer&codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getdryreeferFilters() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetDryReeferFilters');
        }

        function getdryreeferList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetDryReeferList', model);
        }

        function getdryreeferListExcel(model, fileName) {
            common.httpPostFile(config.basePaths.Base_Path_Resources + 'reportList/PrintDryReeferReport', model, fileName);
        }
    }

})();
